import styled from 'styled-components';

export const ProfissionalCardWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  margin: 20px 12px;
  padding: 7px;

  .avatar-doctor {
    width: 160px;
    height: 160px;
    border-radius: 15px;
    object-fit: cover;
  }

  .main-info {
    display: flex;
    flex-direction: column;
    margin-left: 25px;

    div {
      display: flex;
      align-items: center;
      gap: 6px;

      span {
        font-size: var(--font-small);
      }
    }

    h2 {
      font-family: Inter Bold;
      font-size: var(--font-larger);
      margin-bottom: 4px;
    }

    h4 {
      margin-bottom: 18px;
      color: var(--primary-color);
      font-family: Inter;
      font-size: var(--font-small);
    }
  }
`;
